
import React, { useState, useEffect } from "react";
import ObjectForm from "../../Common/ObjectForm";
import http from "../../Common/RestAPIHandler";

const EmployeeCredentialForm = props => {
  const [formFields, setFormFields] = useState();
	const [categories, setCategories] = useState([]);  

	useEffect(() => {
		http.Get(
			`categories?tenant=${props.companyTenant?props.companyTenant.id:null}&category_type=Account Type`,
			(data) => {
				var valueMap = {};
				for (let i = 0; i < data.length; i++) {
					valueMap[data[i].id] = data[i].category_name;
				}
				setCategories(valueMap);
			},
			() => {}
		);
  }, []);

  useEffect(() => {
    if(categories){
      setFormFields([
        { 
          id: "category", 
          label: "ACCOUNT TYPE", 
          type: "select",
          valueMap: categories
        },
        { 
          id: "description", 
          label: "DESCRIPTION", 
          type: "text", 
        },
        { 
          id: "username", 
          label: "USERNAME *", 
          type: "text", 
        },
        { 
          id: "password", 
          label: "PASSWORD *", 
          type: "password", 
        },
        { 
          id: "website", 
          label: "WEBSITE", 
          type: "text", 
        },
      ]);

    }

  }, [categories]);


  return(
    <div>{formFields && <ObjectForm {...props} url={`employee_credentials`} formName={"Employee Credential"} formFields={formFields}/>}</div>
  );
};

export default EmployeeCredentialForm;
